// extracted by mini-css-extract-plugin
export default {"wrapper":"zt7ik","image-card":"gQGqA","title":"LNnRT"};